import { Select, Option, Typography } from '@material-tailwind/react';
import MsgInputError from './MsgInputError';
import { Controller } from 'react-hook-form';
import React, { useEffect, useState } from 'react';

const SelectGlobal = ({
  formCamp,
  array,
  label,
  errors,
  validations,
  css = '',
  defaut = '',
  required,
  control,
  cssDiv = '',
}) => {
  const [focus, setFocus] = useState(false);
  useEffect(() => {
    if (defaut) {
      setFocus(true);
    }
  });

  return (
    <div className={`md:w-[100%] flex-1 ${cssDiv}`}>
      <Typography
        variant="h6"
        color="black"
        className="mb-1 text-left font-medium dark:!text-darkText"
      >
        {label} *
      </Typography>
      <Controller
        name={formCamp} // Nome do campo
        control={control} // Controle do React Hook Form
        defaultValue={defaut} // Valor padrão
        rules={validations} // Passando as validações
        render={({ field }) => {
          return (
            array.length > 0 && (
              <Select
                key={label}
                label={`Selecione ${label}`}
                error={Boolean(errors)} // Se houver erro, aplica o estilo
                size="lg"
                className={`${
                  errors
                    ? `!placeholder:text-red-400 placeholder:text-red-400  focus:!border-red-900 focus:!border-t-red-900 focus:ring-gray-900/10  border-t-red-900`
                    : ' placeholder:text-gray-500  text-gray-900 !border !border-gray-300  placeholder:opacity-100 focus:!border-blue-900 focus:!border-t-blue-900 focus:ring-gray-900/10 '
                } placeholder:opacity-100   bg-white capitalize ${css} dark:bg-!darkBgInput uppercase`}
                labelProps={{ className: `${focus && 'hidden'}` }}
                {...field} // Props do Hook Form (inclui onChange e value)
                onFocus={() => setFocus(true)}
              >
                {array.map((item) => (
                  <Option
                    key={item.id}
                    value={`${item.id}`}
                    className="capitalize"
                    data-id={item.id}
                  >
                    {item.nome}
                  </Option>
                ))}
              </Select>
            )
          );
        }}
      />
      {/* )} */}

      {errors && <MsgInputError text={'Este campo é obrigatório'} />}
    </div>
  );
};

export default SelectGlobal;
